import { __assign } from "tslib";
import { mergeClasses, useArrowNavigationGroup, } from '@fluentui/react-components';
import React from 'react';
import { useFlexPanelStyles } from './FlexPanel.styles';
/**
 * Container control used in various places of AppBar layout
 * @param props FlexPanel props
 * @param forwardRef Forwarded ref
 * @returns JSX.Element
 */
var FlexPanelRender = function (props, forwardRef) {
    var styles = useFlexPanelStyles();
    var keyNavAttr = useArrowNavigationGroup({
        circular: true,
        axis: props.keyNavigationDirection,
        tabbable: props.tabbable,
        memorizeCurrent: props.memorizeCurrent,
    });
    var flexPanelStyles = React.useMemo(function () {
        return mergeClasses(styles.root, props.backgroundShadeClass, props.className, !props.horizontal && styles.column, props.wrap && styles.wrap, props.transparent && styles.transparent, props.fill && styles.fill, props.role === 'navigation' && styles.resizable, props.mercuryDesignEnabled && styles.mercuryFlex);
    }, [props, styles]);
    return (React.createElement("div", __assign({ ref: forwardRef, className: flexPanelStyles, role: props.role, "aria-label": props['aria-label'] }, (props.keyNavigationDirection && keyNavAttr)), props.children));
};
export var FlexPanel = React.forwardRef(FlexPanelRender);
//# sourceMappingURL=FlexPanel.js.map